<template>
    <div v-if="currentNotification" id="notification-container"
         :class="getBackgroundByType(currentNotification.type) + ' ml-auto col-10 col-md-4 col-lg-3 w-100 ' + ((currentNotification.type === 'ERROR') ? 'animation-error' : 'animation-success')">
        <div class="d-flex w-100 justify-content-between align-items-baseline">
            <div>
                <h3 v-if="currentNotification.type === 'SUCCESS'" >Successo</h3>
                <h3 v-if="currentNotification.type === 'ERROR'" >Errore</h3>
                <h3 v-if="currentNotification.type === 'INFO'" >Info</h3>
            </div>
            <div>
                <p>{{ currentNotification.message }}</p>
            </div>
            <a
                v-show="currentNotification.type === 'ERROR'"
                data-cy="notify-btn-error"
                class="close"
                aria-label="Close"
                @click="closeNotification">
                <span aria-hidden="true">&times;</span>
            </a>
        </div>
    </div>
</template>

<script>
    import { EventBus } from "@/event-bus";


    export default {

        data() {
            return {
                processing: false,
                notifications: [],
                currentNotification: null,
                types: ['SUCCESS', 'ERROR', 'INFO']
            }
        },

        created() {
            let vm = this;
            EventBus.$on('newNotification', notification => {
                if (Object.prototype.hasOwnProperty.call(notification, 'message') && Object.prototype.hasOwnProperty.call(notification, 'type')) {
                    notification.message = this.parseMessage(notification.message);
                    vm.notifications.push(notification);
                }
            });
        },

        methods: {

            processNotification() {

                let vm = this;

                if (vm.notifications.length && !vm.processing) {
                    vm.processing = true;
                    vm.currentNotification = vm.notifications[0];

                    if (vm.currentNotification.type === 'ERROR') {
                        return;
                    }

                    return setTimeout(function () {
                        vm.processing = false;
                        vm.currentNotification = null;

                        setTimeout(function () {
                            vm.notifications.shift();
                        }, 200);

                    }, 3000);
                }
            },

            closeNotification() {
                let vm = this;
                this.processing = false;
                this.currentNotification = null;

                setTimeout(function () {
                    vm.notifications.shift();
                }, 200);
            },

            getBackgroundByType(type) {
                switch (type) {
                    case 'SUCCESS':
                        return 'bg-success';
                    case 'ERROR':
                        return 'bg-danger';
                    case 'INFO':
                        return 'bg-info';
                    default:
                        return 'bg-success';
                }
            },

            parseMessage(message) {

                if (message == null) {
                    return null;
                }

                if (typeof message === 'string' || message instanceof String) {
                    return message;
                }

                if (message.data && message.data.errors) {
                    let msg = '';

                    for (let k in message.data.errors) {
                        msg += message.data.errors[k] + '\n';
                    }
                    return msg;
                }

                return null;
            }

        },

        watch: {
            notifications() {
                this.processNotification();
            }
        }
    }
</script>
<style scoped>
#notification-container {
    display: flex;
    position: fixed;
    align-items: center;
    top: 0;
    z-index: 100;
    border-radius: .35rem;
    color: white;
    padding: 1em;
    height: 10%;
}
.bg-success {
    background-color: black;
}
.bg-danger {
    background-color: red;
}
.bg-info {
    background-color: cadetblue;
}
.w-100 {
    width: 100%;
}
.d-flex {
    display: flex;
}
.justify-content-between {
    justify-content: space-between;
}
.align-items-baseline {
    align-items: baseline;
}
.close {
    font-size: 25px;
    font-weight: 800;
    opacity: 0.4;
}
.close:hover {
  opacity: 1;
}
.animation-success {
    animation-name: fade-notification;
    animation-duration: 3s;
    animation-timing-function: linear;
}

.animation-error {
    animation-name: fade-notification-error;
    animation-duration: 3s;
    animation-timing-function: linear;
    animation-fill-mode: forwards;
}

@keyframes fade-notification-error {
    0% {
        bottom: 0;
        opacity: 0;
    }
    10%, 100% {
        bottom: 20px;
        opacity: 1;
    }
}

@keyframes fade-notification {
    0%, 100% {
        bottom: 0;
        opacity: 0;
    }
    10% {
        bottom: 20px;
        opacity: 1;
    }
    90% {
        bottom: 20px;
        opacity: 1;
    }
}
</style>